import { createTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import * as React from "react"
import { createContext } from "react"

var screenSize = "lg"

const screenSizeContext = createContext()

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 320,
      sm: 768,
      md: 1024,
      lg: 1440,
    },
  },
})

function ResponsiveHandler(props) {
  const xs = useMediaQuery(theme.breakpoints.between(0, "sm"))
  const sm = useMediaQuery(theme.breakpoints.between("sm", "md"))
  const md = useMediaQuery(theme.breakpoints.between("md", "lg"))
  const lg = useMediaQuery(theme.breakpoints.up("lg"))

  if (lg) {
    screenSize = "lg"
  } else if (md) {
    screenSize = "md"
  } else if (sm) {
    screenSize = "sm"
  } else if (xs) {
    screenSize = "xs"
  }

  return (
    <div>
      <screenSizeContext.Provider value={screenSize}>
        {props.children}
      </screenSizeContext.Provider>
    </div>
  )
}

export { ResponsiveHandler, screenSizeContext }
